import { exchangeUserIdentifiers } from './auth-new'
import { Auth } from '@aws-amplify/auth'
import store from '../store'
import getLoggedUser from './get-logged-user'
import {
    getUrlParameter,
    removeQuery,
    setEcho,
} from './index'
import { saveUserIntoLocalStorage } from '../reducers/auth'
import {
    EVENT_REGISTRATION,
    sendWebViewEvent,
} from '../../events-webview'

/**
 * Sets currently authenticated user
 * @returns {*}
 */
const setAuthenticatedUser = data => {
    return getLoggedUser()
        .then(loggedUser => {
            store.dispatch({ type: 'CLEAR_LOGIN_ERROR' })
            store.dispatch({
                type: 'TOGGLE_BUSY_SECTION',
                section: 'registration',
            })

            setEcho(data)

            saveUserIntoLocalStorage(loggedUser, 'facebook')

            const eventData = {
                close: true,
                data: {
                    user: loggedUser,
                    tokens: data,
                    loginCredentials: null,
                },
            }

            if (sendWebViewEvent(EVENT_REGISTRATION, eventData) !== false) {
                return
            }

            const successAction = store.getState().app.login.successAction

            if (typeof successAction === 'function') {
                successAction()
            }
        })
}

/**
 * @Deprecated Use only for old login a registration forms.
 * Login over Facebook
 *
 * @param {Object} response
 * @return {Promise}
 */
export const deprecatedFacebookAuth = response => {
    if (response.accessToken) {
        const token = response.accessToken

        store.dispatch({
            type: 'TOGGLE_BUSY_SECTION',
            section: 'registration',
        })

        return window.axios.get(`${window.APP_CONFIG.REACT_APP_API_URL}api/auth/facebook/callback?system=${window.APP_CONFIG.REACT_APP_SYSTEM}&token=${token}`).then(({ data }) => {
            if (getUrlParameter('code')) {
                removeQuery('code')
                removeQuery('state')
            }

            localStorage.setItem('sportnect.tokens', JSON.stringify(data))
            store.dispatch({
                type: 'SET_STORE_TOKENS',
                tokens: data,
            })

            window.axios.defaults.headers.common.Authorization = `Bearer ${data.access_token}`

            return setAuthenticatedUser(data)
        }).catch(err => {
            setErrorMessageAndToggleBusy(err?.response?.data)
        })
    }

    return new Promise(resolve => resolve())
}

/**
 * Logs in cognito facebook user via cognito hosted UI redirect
 */
export const loginCognitoFacebookUser = () => {
    const config = Auth.configure()

    const {
        domain,
        redirectSignIn,
        responseType,
        scope,
    } = config.oauth

    const clientId = config.userPoolWebClientId

    const url = `https://${domain}/oauth2/authorize?identity_provider=Facebook&redirect_uri=${redirectSignIn}&response_type=${responseType}&client_id=${clientId}&scope=${scope.join(' ')}&state=provider=Facebook`

    window.location.assign(url)
}

/**
 * Login over Facebook
 *
 * @param {Object} response
 * @return {Promise}
 */
export default response => {
    if (response.accessToken) {
        const token = response.accessToken

        sessionStorage.setItem('facebookAccessToken', token)

        if (sessionStorage.getItem('facebookRedirectCount') === '1') {
            sessionStorage.setItem('facebookRedirectCount', '2')
        } else {
            sessionStorage.setItem('facebookRedirectCount', '1')
        }

        store.dispatch({
            type: 'TOGGLE_BUSY_SECTION',
            section: 'registration',
        })

        if (!Auth) {
            return window.swalert('Funkce autorizace není momentálně dostupná')
        }

        loginCognitoFacebookUser()
    }

    return new Promise(resolve => resolve())
}

/**
 * Logs in user via API with facebook
 * @param {string} accessToken
 * @returns {Promise<any>}
 */
export const loginUserViaFacebookWithApi = accessToken => (
    requestLoginUserViaFacebookWithApi(accessToken)
        .then(({ data }) => {
            if (getUrlParameter('code')) {
                removeQuery('code')
                removeQuery('state')
            }

            localStorage.setItem('sportnect.tokens', JSON.stringify(data))

            store.dispatch({
                type: 'SET_STORE_TOKENS',
                tokens: data,
            })

            window.axios.defaults.headers.common.Authorization = `Bearer ${data.access_token}`

            return setAuthenticatedUser(data)
                .then(() => exchangeUserIdentifiers())
        })
        .catch(err => setErrorMessageAndToggleBusy(err?.response?.data))
)

/**
 * Login user via Facebook on API
 * @param {string} accessToken
 * @returns {AxiosPromise<any>}
 */
const requestLoginUserViaFacebookWithApi = accessToken => (
    window.axios.get(`${window.APP_CONFIG.REACT_APP_API_URL}api/auth/facebook/callback?system=${window.APP_CONFIG.REACT_APP_SYSTEM}&token=${accessToken}`)
)

/**
 * Set login error message in store and toggle busy registration section
 * @param {string|null} errorMessage
 */
const setErrorMessageAndToggleBusy = errorMessage => {
    if (errorMessage) {
        store.dispatch({
            type: 'SET_LOGIN_ERROR',
            code: errorMessage,
        })
    }

    store.dispatch({
        type: 'TOGGLE_BUSY_SECTION',
        section: 'registration',
        force: false,
    })
}
